/* Velunaris Signature: kleine Momente ohne Saisonbezug.
   Farbleuchten je Variante, Goldfunken beim Warenkorb, "gutenacht"-Easter-Egg, leere Bewertungsbloecke ausblenden. */
(function () {
  'use strict';
  if (window.Shopify && window.Shopify.designMode) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var GLOWS = { nachtschwarz: 'rgba(34,34,72,.30)', mitternachtsblau: 'rgba(71,112,219,.32)', sternenlicht: 'rgba(236,208,140,.50)' };
  function ready(fn) { document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn, { once: true }) : fn(); }

  function glowFor(value) {
    var v = String(value || '').toLowerCase();
    for (var key in GLOWS) if (v.indexOf(key) > -1) return GLOWS[key];
    return null;
  }
  function applyGlow(value) {
    var c = glowFor(value); if (!c) return;
    Array.prototype.forEach.call(document.querySelectorAll('.product__media-wrapper'), function (el) { el.style.setProperty('--vlp-glow', c); });
  }
  function initVariantGlow() {
    var checked = document.querySelector('.product-form__input input[type=radio]:checked');
    if (checked) applyGlow(checked.value);
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('input[type=radio]') && t.closest('.product-form__input')) applyGlow(t.value);
    });
  }

  function initCartSpark() {
    if (reduce) return;
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.product-form__submit');
      if (!b || b.disabled || b.getAttribute('aria-disabled') === 'true') return;
      var r = b.getBoundingClientRect(), box = document.createElement('div');
      box.className = 'vlp-burst';
      box.style.left = r.left + r.width / 2 + 'px';
      box.style.top = r.top + r.height / 2 + 'px';
      for (var i = 0; i < 12; i++) {
        var s = document.createElement('i'), a = Math.PI * 2 * i / 12 + Math.random() * .5, d = 46 + Math.random() * 46;
        s.style.setProperty('--dx', Math.cos(a) * d + 'px');
        s.style.setProperty('--dy', Math.sin(a) * d + 'px');
        s.style.animationDelay = Math.random() * 80 + 'ms';
        box.appendChild(s);
      }
      document.body.appendChild(box);
      window.setTimeout(function () { box.remove(); }, 1300);
    }, true);
  }

  function nightMode(done) {
    var box = document.createElement('div');
    box.className = 'vlp-night' + (reduce ? ' vlp-night--calm' : '');
    box.setAttribute('role', 'status');
    if (!reduce) for (var i = 0; i < 46; i++) {
      var s = document.createElement('span'), size = 1 + Math.random() * 3;
      s.style.left = Math.random() * 100 + '%'; s.style.top = Math.random() * 100 + '%';
      s.style.width = size + 'px'; s.style.height = size + 'px';
      s.style.animationDelay = Math.random() * 2.6 + 's';
      box.appendChild(s);
    }
    var p = document.createElement('p'); p.textContent = 'Gute Nacht'; box.appendChild(p);
    document.body.appendChild(box);
    window.requestAnimationFrame(function () { box.classList.add('on'); });
    window.setTimeout(function () { box.classList.remove('on'); }, 4600);
    window.setTimeout(function () { box.remove(); done(); }, 6000);
  }
  function initNightEgg() {
    var buf = '', word = 'gutenacht', busy = false;
    document.addEventListener('keydown', function (e) {
      var t = e.target;
      if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.tagName === 'SELECT' || t.isContentEditable)) return;
      if (!e.key || e.key.length !== 1) return;
      buf = (buf + e.key.toLowerCase()).slice(-word.length);
      if (buf === word && !busy) { busy = true; nightMode(function () { busy = false; }); }
    });
  }

  function hideEmptyHomeReviews() {
    var main = document.querySelector('main[data-template]');
    if (!main || main.getAttribute('data-template') !== 'index') return;
    var tries = 0, timer = window.setInterval(function () {
      tries++;
      Array.prototype.forEach.call(document.querySelectorAll('.jm-review-widget__header-and-body'), function (w) {
        if (/Keine Elemente gefunden/i.test(w.textContent)) { var s = w.closest('.shopify-section'); if (s) s.style.display = 'none'; }
      });
      if (tries > 14) window.clearInterval(timer);
    }, 700);
  }

  ready(function () { initVariantGlow(); initCartSpark(); initNightEgg(); hideEmptyHomeReviews(); });
})();